import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { ProgressSpinner } from "primereact/progressspinner";

const View = () => {
  const { id } = useParams();
  const [cashCountData, setCashCountData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCashCountData();
  }, [id]);

  const fetchCashCountData = async () => {
    try {
      setLoading(true);
      const response = await Http.get(`/cash-count/${id}`);
      setCashCountData(response.data);
      setError(null);
    } catch (err) {
      setError("Failed to fetch cash count details");
      console.error("Error fetching cash count:", err);
    } finally {
      setLoading(false);
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'bdt',
      minimumFractionDigits: 2
    }).format(amount || 0);
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const denominationData = [
    { label: 'Thousand (BDT 1000)', field: 'thousand', qty_field: 'thousand', total_field: 'thousand_total', value: 1000 },
    { label: 'Five Hundred (BDT 500)', field: 'five_hundred', qty_field: 'five_hundred', total_field: 'five_hundred_total', value: 500 },
    { label: 'Two Hundred (BDT 200)', field: 'two_hundreed', qty_field: 'two_hundred', total_field: 'two_hundred_total', value: 200 },
    { label: 'One Hundred (BDT 100)', field: 'hundreed', qty_field: 'one_hundred', total_field: 'one_hundred_total', value: 100 },
    { label: 'Fifty (BDT 50)', field: 'fifty', qty_field: 'fifty', total_field: 'fifty_total', value: 50 },
    { label: 'Twenty (BDT 20)', field: 'twenty', qty_field: 'twenty', total_field: 'twenty_total', value: 20 },
    { label: 'Ten (BDT 10)', field: 'ten', qty_field: 'ten', total_field: 'ten_total', value: 10 },
    { label: 'Five (BDT 5)', field: 'five', qty_field: 'five', total_field: 'five_total', value: 5 },
    { label: 'Two (BDT 2)', field: 'two', qty_field: 'two', total_field: 'two_total', value: 2 },
    { label: 'One (BDT 1)', field: 'one', qty_field: 'one', total_field: 'one_total', value: 1 }
  ];
  console.log(denominationData);

  if (loading) {
    return (
      <div>
        <IsLogin />
        <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
          <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <IsLogin />
        <div className="alert alert-danger text-center">
          <h4>Error</h4>
          <p>{error}</p>
          <Link to="/cash-count" className="btn btn-primary">Back to Cash Count List</Link>
        </div>
      </div>
    );
  }

  if (!cashCountData) {
    return (
      <div>
        <IsLogin />
        <div className="alert alert-warning text-center">
          <h4>No Data Found</h4>
          <p>Cash count record not found.</p>
          <Link to="/cash-count" className="btn btn-primary">Back to Cash Count List</Link>
        </div>
      </div>
    );
  }

  return (
    <div>
      <IsLogin />
      <style>
        {`
          .cash-count-view-page {
            padding: 20px;
            background-color: #f8f9fa;
            min-height: calc(100vh - 120px);
          }
          .view-header {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            padding: 20px;
            border-radius: 10px;
            margin-bottom: 20px;
            box-shadow: 0 4px 15px rgba(0,0,0,0.1);
          }
          .detail-card {
            background: white;
            border-radius: 10px;
            padding: 20px;
            margin-bottom: 20px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.08);
            border: 1px solid #e9ecef;
          }
          .denomination-item {
            background: #f8f9fa;
            border: 1px solid #e9ecef;
            border-radius: 8px;
            padding: 12px;
            margin-bottom: 8px;
            transition: all 0.2s ease;
          }
          .denomination-item:hover {
            background: #e3f2fd;
            border-color: #2196f3;
          }
          .denomination-value {
            font-size: 1em;
            font-weight: 600;
            color: #2c3e50;
          }
          .summary-badge {
            background: linear-gradient(45deg, #667eea, #764ba2);
            color: white;
            padding: 8px 16px;
            border-radius: 20px;
            font-weight: 600;
            display: inline-block;
            margin: 4px;
            font-size: 0.9em;
          }
          .btn-custom {
            border-radius: 6px;
            padding: 8px 16px;
            font-weight: 500;
            margin: 0 4px;
            font-size: 0.9em;
          }
          .section-title {
            color: #2c3e50;
            font-weight: 700;
            margin-bottom: 15px;
            padding-bottom: 8px;
            border-bottom: 2px solid #667eea;
            font-size: 1.2em;
          }
          .info-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 8px 0;
            border-bottom: 1px solid #eee;
          }
          .info-label {
            font-weight: 600;
            color: #555;
            font-size: 0.9em;
          }
          .info-value {
            color: #2c3e50;
            font-weight: 500;
            font-size: 0.9em;
          }
          .page-title {
            margin-bottom: 0;
            font-size: 1.5em;
          }
          .page-subtitle {
            margin-bottom: 0;
            opacity: 0.8;
            font-size: 0.9em;
          }
        `}
      </style>
      <div>
        <div className="am-mainpanel">
        <div className="am-pagetitle">
          <div>
            <h5 className="am-title mb-1">Cash Count Details</h5>
            <p className="text-muted mb-0">Comprehensive view of cash count record #{cashCountData.date}</p>
          </div>
          <div className="d-flex gap-2">
            <Link to="/cash-count" className="btn btn-secondary btn-custom">
              <i className="fa fa-arrow-left me-1"></i>Back to List
            </Link>
            <button 
              className="btn btn-info btn-custom"
              onClick={() => window.print()}
            >
              <i className="fa fa-print me-1"></i>Print
            </button>
          </div>
        </div>
        
        <div className="cash-count-view-page">
          <div className="container-fluid">


            <div className="row">
              {/* Basic Information */}
              <div className="col-md-4">
                <div className="detail-card">
                  <h4 className="section-title">Basic Information</h4>
                  <div className="info-row">
                    <span className="info-label">Date:</span>
                    <span className="info-value">{formatDate(cashCountData.date)}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Record ID:</span>
                    <span className="info-value">#{cashCountData.id}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Created:</span>
                    <span className="info-value">{formatDate(cashCountData.created_at)}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Last Updated:</span>
                    <span className="info-value">{formatDate(cashCountData.updated_at)}</span>
                  </div>
                </div>

                {/* Summary */}
                <div className="detail-card">
                  <h4 className="section-title">Summary</h4>
                  <div className="text-center">
                    <div className="summary-badge">
                      Total Amount: {formatCurrency(cashCountData.total_amount)}
                    </div>
                    <div className="summary-badge">
                      Suspense: {formatCurrency(cashCountData.suspense)}
                    </div>
                    <div className="summary-badge">
                      Net Total: {formatCurrency((cashCountData.total_amount || 0) + (cashCountData.suspense || 0))}
                    </div>
                  </div>
                </div>
              </div>

              {/* Denomination Breakdown */}
              <div className="col-md-8">
                <div className="detail-card">
                  <h4 className="section-title">Denomination Breakdown</h4>
                  <div className="row">
                    {denominationData.map((denom, index) => {
                      const quantity = cashCountData[denom.qty_field] || 0;
                      const total = quantity * denom.value;
                      
                      if (quantity === 0) return null;
                      
                      return (
                        <div key={index} className="col-md-6 mb-3">
                          <div className="denomination-item">
                            <div className="d-flex justify-content-between align-items-center">
                              <div>
                                <div className="denomination-value">{denom.label}</div>
                                <small className="text-muted">Quantity: {quantity}</small>
                              </div>
                              <div className="text-end">
                                <div className="denomination-value text-success">
                                  {formatCurrency(total)}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  
                  {/* Show all denominations including zero quantities */}
                  <div className="mt-4">
                    <h5 className="text-muted mb-3">Complete Breakdown (All Denominations)</h5>
                    <div className="table-responsive">
                      <table className="table table-striped">
                        <thead className="table-dark">
                          <tr>
                            <th>Denomination</th>
                            <th>Quantity</th>
                            <th>Value Each</th>
                            <th>Total Value</th>
                          </tr>
                        </thead>
                        <tbody>
                          {denominationData.map((denom, index) => {
                            const quantity = cashCountData[denom.qty_field] || 0;
                            const total = quantity * denom.value;
                            
                            return (
                              <tr key={index} className={quantity > 0 ? 'table-success' : ''}>
                                <td>{denom.label}</td>
                                <td>{quantity}</td>
                                <td>{formatCurrency(denom.value)}</td>
                                <td className="fw-bold">{formatCurrency(total)}</td>
                              </tr>
                            );
                          })}
                          <tr className="table-warning">
                            <td colSpan="3" className="fw-bold">Suspense Amount</td>
                            <td className="fw-bold">{formatCurrency(cashCountData.suspense)}</td>
                          </tr>
                          <tr className="table-primary">
                            <td colSpan="3" className="fw-bold">Grand Total</td>
                            <td className="fw-bold">{formatCurrency((cashCountData.total_amount || 0) + (cashCountData.suspense || 0))}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
     </div>
   );
};

export default View;